import { ThemeConfig } from "../../../shared/theme";
import * as theme from './clic';
const ThemeComponents: ThemeConfig = {
    'clic': {
        component: theme,
        css: ['/static/customized/themes/clic/css/extension.css', '/static/customized/themes/clic/css/common.css', '/static/customized/themes/clic/css/blue.css'],
        layouts: {
            'default': theme.DefaultLayout,
            'empty': theme.EmptyLayout
        }
    }
};

export default ThemeComponents;
